export const compressedImageFilter = `quality(95)format(webp)`;

const isStoryblokHosted = url => {
  try {
    return new URL(url).hostname === 'a.storyblok.com';
  } catch {
    return false;
  }
}

export const addStoryblokImageServiceWebpSupport = url => {
  if (!url) return "";
  if (url.endsWith('.svg')) return url;
  if (!isStoryblokHosted(url)) return url;
  
  let current = `${url}`
  if(current.indexOf('/m/') === -1) {
    if(current.endsWith("/")) {
      current = current+"m/"
    } else {
      current = current+"/m/"
    }
  }

  return current
}

export const useCompressedImage = (url) => {
  const base = addStoryblokImageServiceWebpSupport(url);
  if (!base.endsWith('/m/')) return base;
  return `${base}filters:${compressedImageFilter}`
};
